import styled, { css } from 'styled-components';
import { MHighlightTextAlignment } from './MHighlightText.types';

interface WrapperProps {
  alignment: MHighlightTextAlignment;
}

export const Wrapper = styled.div<WrapperProps>`
  display: flex;
  flex-direction: column;

  ${({ alignment }) =>
    alignment === MHighlightTextAlignment.Centered
      ? css`
          align-items: center;
          text-align: center;
        `
      : css`
          align-items: flex-start;
          text-align: left;
        `}
`;
